window.initRequestPayoutForm = function() {
	setCurrency();
	$('[name="assessor_payout[assessment_id]"]').on('change', function(){
		setCurrency();
	})
}

function setCurrency(default_currency='AED') {
	let currency = $('[name="assessor_payout[assessment_id]"]').find('option:selected').attr('data-currency');
	if(currency) {
		$('.js-currency').text(currency);
	} else {
		$('.js-currency').text(default_currency);
	}
}